import { loadStripe } from '@stripe/stripe-js';

let domain = 'local'
let version = 'stage';
let stripePromise = loadStripe("pk_test_51HGJFvARqlCjj4b98dGKPv0wmGuBnhd1UlEELmE0B7LWglLJi03i6ieQDjZ3IOu8Hd5oshnSTaUsUPRlLVcBwvUT00mnga5GLc");

const environment = window.location.host.replace('https://', '').replace(/\.?app.buddy.hr/, '')

switch (environment) {
	case 'uk':
	case 'stage':
	case 'review':
		domain = environment
		version = environment
		break
	case '':
		domain = 'live'
		version = 'v2'
		stripePromise = loadStripe("pk_live_51HaNWTFTZstRS4WcgEj195NFq0vhkZfc79rYpxhpuWxPD31NGM7j8gRChTJb65wziOuyMEGgFMPsKkfmDruGT8Q000keA5Xgde")
		break
}

const apiURL = `https://api.buddy.hr/${version}`;

if (domain !== 'live') console.debug({apiURL, version, domain});

export { apiURL as default, version, domain, stripePromise }
